/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React from "react";
import Icon from "../../assets/image/FailedActivation.svg";
import Footer from "../../footer/Footer";
import { string } from "../../constant/string";

/**
 * Account activation failed  page
 *
 * @returns JSX for account activation failed  page
 */
const FailedActivation = () => {
  return (
    <div className="finalPageMain">
      {/* Parant container */}
      <div className="parantContainer">
        {/* Icon for the page */}
        <div>
          <img className="icon" src={Icon} alt="Activation Failed"></img>
        </div>
        {/* Main text on the screen */}
        <div className="mainText-error"> {string.ACTIVATION_FAILED}</div>
        {/* Paragraph text on the screen */}
        <div className="paraText">
          {string.WE_WERE_UNABLE_TO_ACTIVATE_YOUR_ACCOUNT_DUE_TO_SOME_TECHNICAL_ISSUES}
          <br /> <br />
          {string.OUR_SUPPORT_TEAM_HAS_BEEN_NOTIFIED_AND_WILL}
          <br />
          <strong>{string.REACH_OUT_TO_ASSIST_YOU_IN_THE_NEXT_24_HOURS}</strong>
        </div>
      </div>
      {/* Footer on the screen */}
      <Footer />
    </div>
  );
};

export default FailedActivation;
